import { Layout } from 'components/common/layout/Layout';
import React from 'react';
import { getClientEnv } from '../client/clientEnv';
import { ExampleProfile } from '../components/players/ExamplePlayer';
import { Espin_Game_Definition_Enum, PlayerProfileFragment } from '../generated/spin-graphql';

export default function ExamplePlayer() {
    const player: PlayerProfileFragment = {
        user: {
            id: '',
            email: 'kyle.taylor@carolinaesports.gg',
        },
        first_name: 'Kyle',
        last_name: 'Taylor',
        spin_username: 'taylsspin1',
        bio: `This is where you would describe more about yourself as a player. What are your strengths inside and outside of the game? What are you looking for in a college or university? Use this area to "market" yourself better!`,
        graduating_class: '2025',
        primary_game: [
            {
                rank: 'SSL',
                role: '2nd Man',
                tracker: 'https://staypluggedin.com',
                game: {
                    game_definition: Espin_Game_Definition_Enum.RocketLeague,
                    name: 'Rocket League',
                },
            },
        ],
        address: {
            city: 'Charlotte',
            state: 'North Carolina',
            country: 'United States',
        },
        phone: '9999999999',
        preferred_schools: ['UNC Chapel Hill', 'Shenandoah University', 'NC State'],
        preferred_study_fields: ['Product Development', 'Computer Science', 'Programming'],
        gpa: 4,
        is_hs: true,
        college_name: 'College Name Here',
        social: {
            twitch_channel: {
                id: '',
                link_data: 'staypluggedin',
            },
            youtube_channel: {
                id: '',
                link_data: 'channel/UCP3Bvpzqm1kJFBX2MuMnm-A',
            },
            twitter: '@taylsspin',
            facebook: '',
            discord: 'Stay Plugged In#8093',
            tiktok: '@staypluggedin',
            instagram: 'stay_pluggedin',
        },
        id: '',
        user_id: '',
        player_vods: [],
        slug: '',
        profile_image: {
            id: 'example-profile-picture',
            cdn_url: getClientEnv().NEXT_PUBLIC_IMAGE_HOST,
            original_name: 'example-profile-picture.jpg',
            ext: 'jpg',
        },
    };

    return (
        <Layout>
            <ExampleProfile player={player} />
        </Layout>
    );
}
